import { type InjectionKey, inject, type App } from 'vue'
import { MobileMissionsApiClient } from '../generated/api/MobileMissionsApiClient'

class MobileMissionsApiNotProvidedError extends Error {}

export const mobileMissionsApiClientKey = Symbol() as InjectionKey<MobileMissionsApiClient>

// Must call in Vue component. Provides MobileMissionsApiClient via
// `useMobileMissionsApiClient` in all components subtree.
export function provideMobileMissionsApiClient(app: App, apiClient: MobileMissionsApiClient) {
  app.provide(mobileMissionsApiClientKey, apiClient)
}

// Must call in Vue component. Injects MobileMissionsApiClient using
// Vue's DI framework. Throws error if not provided in this component tree.
export function useMobileMissionsApiClient() {
  const apiClient = inject(mobileMissionsApiClientKey)
  if (apiClient === undefined) {
    throw new MobileMissionsApiNotProvidedError()
  }

  return apiClient
}
